"use client"

import { useEffect } from "react"
import { usePathname } from "next/navigation"
import { installContentLinkListener } from "@/lib/analytics/content-links"

/**
 * Mounts the single delegated `content_link_clicked` listener for a content
 * route. One per page: the listener itself is idempotent per click event, but
 * a second instance would still add a second DOM listener.
 */
export function ContentLinkTracker() {
  const pathname = usePathname()

  useEffect(() => installContentLinkListener(() => pathname), [pathname])

  return null
}
